import { EDealTypeEx } from '../repositories/demand/v4/create-message';
import { addressMapper, geoMapper } from '../actions/submitForm/utils/mappers';

export const getGeoMapper = (dealTypeEx: EDealTypeEx) => {
  if (dealTypeEx === EDealTypeEx.Sale || dealTypeEx === EDealTypeEx.SellToBuy || dealTypeEx === EDealTypeEx.Rent) {
    return addressMapper;
  } else {
    return geoMapper;
  }
};
